export default __webpack_public_path__ + "static/media/icon-puzzle.2d878a3e.svg";